module.exports = __webpack_public_path__ + "img/icon-arrow-light.274e01b9.svg";